import axios from 'axios';
import globals from "../config/appconfig";
import Utils from "../utils/Utils";

export default class ContactTracingServices {

    static urlContactTracing = globals["app-url-backend-anagrafica"] + "/pazienti/contactTracing/{idSegnalazione}"
    static urlDeleteContactTracing = globals["app-url-backend-anagrafica"] + "/pazienti/contactTracing"
    static urlGetNumeroContatti=globals["app-url-backend-anagrafica"] +"/pazienti/contactTracing/numeroContatti"

    static getContactTracing(params, idSegnalazione) {

        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlContactTracing.replace("{idSegnalazione}", idSegnalazione) + querystring)
    }

    static getContatto(idContactTracing) {
        return axios.get(this.urlDeleteContactTracing + "?idContactTracing=" + idContactTracing)

    }

    static postPutContactTracing(jsonInsert, idSegnalazione) {
        return axios.put(this.urlContactTracing.replace("{idSegnalazione}", idSegnalazione), jsonInsert)
    }

    static deleteContactTracing(idContactTracing) {
        return axios.delete(this.urlDeleteContactTracing + "?idContactTracing=" + idContactTracing)

    }

    static mapGetontactTracing(data,dataInvioEmail) {
        let res = [];
        data.data.content.forEach(function (el) {
            el["dataNascita"] = el.dataNascita ? Utils.transformTimeStampForFrontend(el.dataNascita) : null;
            el["dataContatto"] = el.dataContatto ? Utils.transformTimeStampForFrontend(el.dataContatto) : null;
            
            let comuniPerCodice = JSON.parse(sessionStorage.getItem("comuniPerCodice"))
            let comuneDomicilio=el.comuneDomicilio && comuniPerCodice[el.comuneDomicilio]  ? comuniPerCodice[el.comuneDomicilio].descrizione : ""
           
            let datIns= el.timestampInserimento;
            if (dataInvioEmail){
                    if (datIns > dataInvioEmail) {
                        el["nuovoInserimento"] = true

                    } else {
                        el["nuovoInserimento"] = false
                    }
            }else{
            el["nuovoInserimento"] = true
        }


            if (comuneDomicilio && el.indirizzoDomicilio){
                el["comuneDomicilio"]=comuneDomicilio && el.indirizzoDomicilio ? comuneDomicilio + ", " + el.indirizzoDomicilio : null
            }else if (comuneDomicilio){
                el["comuneDomicilio"]=comuneDomicilio
            }else if (el.indirizzoDomicilio){
                el["comuneDomicilio"]=el.indirizzoDomicilio
            }

            res.push(el);
        })
        if (res.length === 0) {
            return data.data.content
        }
        return res
    }

    static getNumeroContatti(idSegnalazione) {
        let url=this.urlGetNumeroContatti+"/" +idSegnalazione
        return axios.get(url)
    }

}
